(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cw-language-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    document.querySelectorAll('.cw-language-menu__details[open]').forEach(function(details) {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cw-language-menu__details[open]').forEach(function(details) {
      if (details.contains(document.activeElement)) details.querySelector('summary').focus();
      details.open = false;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
